<template>
  <figcaption :class="{ 'align-right': !!chat.concierge }">
    <time :datetime="chat.published_at">{{ formatTime(chat.published_at) }}</time>
    <ul v-if="showEvaluation" class="eval" role="aria-hidden">
      <li :class="yesClass" @click="sendEval(chat, 'yes')"></li>
      <li :class="noClass" @click="sendEval(chat, 'no')"></li>
    </ul>
  </figcaption>
</template>

<script>
import { formatTime } from 'Utilities'
import { Chat } from 'src/apis'

export default {
  props: {
    chat: { type: Object, required: true },
    operatorName: { type: String, required: true }
  },
  data() {
    return {
      formatTime,
      chatBubbleIcon: '',
      showEvaluation: this.chat.concierge && this.chat.evaluate, // show evaluation buttons even when already evaluated
      yesClass: this.getClass('liked'),
      noClass: this.getClass('disliked'),
      active: this.chat.evaluate === true // disable evaluation buttons when already evaluated
    }
  },

  methods: {
    getClass(value) {
      // get the class depending on the evaluation received with message
      // if the value is liked -> yes button needs to have clicked and disabled flags
      if (this.chat.evaluate === true) {
        return ''
      } else if (this.chat.evaluate === value) {
        return 'clicked disabled'
      } else {
        return 'disabled'
      }
    },
    sendEval(chat, value) {
      if (this.showEvaluation && this.active) {
        this.active = false
        if (value === 'yes') {
          this.yesClass = 'clicked disabled'
          this.noClass = 'disabled'
        } else {
          this.yesClass = 'disabled'
          this.noClass = 'disabled clicked'
        }
        Chat.SendChatEval(chat.id, value).catch((err) => {
          console.error(err)
          this.showEvaluation = true
        })
      }
    }
  }
}
</script>
